import(/* webpackMode: "eager" */ "/home/oreetiene/public_html/app/(otherPages)/politica-de-confidentialitate/page.jsx");
